function IsEmail(email) {
  var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if (!regex.test(email)) {
    return false;
  } else {
    return true;
  }
}

jQuery(document).ready(function() {

    $('form.search').submit(function(){
      if($(this).find('.search_box').val()==""){
          alert('Please enter search title');
          $(this).find('.search_box').focus();
          return false;
      }
    });
  	
  	class ScrollClass {
      constructor () {
          this.$body = $('body');

          this.styles = {
              disabled: {
                  'height': '100%',
                  'overflow': 'hidden',
              },

              enabled: {
                  'height': '',
                  'overflow': '',
              }
          };
      }

      disable ($element = $(window)) {
          let disabled = false;
          let scrollTop = window.pageYOffset;

          $element
              .on('scroll.disablescroll', (event) => {
                  event.preventDefault();

                  this.$body.css(this.styles.disabled);

                  window.scrollTo(0, scrollTop);
                  return false;
              })
              .on('touchstart.disablescroll', () => {
                  disabled = true;
              })
              .on('touchmove.disablescroll', (event) => {
                  if (disabled) {
                      event.preventDefault();
                  }
              })
              .on('touchend.disablescroll', () => {
                  disabled = false;
              });
      }

      enable ($element = $(window)) {
          $element.off('.disablescroll');

          this.$body.css(this.styles.enabled);
      }
  }

  var Scroll = new ScrollClass();
  
  	$('#mobile_menu').on('show.bs.dropdown', function () {
      $("body").addClass('hidden-scroll');
      Scroll.disable();
    });
  
  	$('#mobile_menu').on('hide.bs.dropdown', function () {
      $("body").removeClass('hidden-scroll');
      Scroll.enable();
    });
  
    $(document).on('click', '.product-custom-rating-box .text-m', function(){
      	if($('#tabs-information ul.nav-tabs li.active a').attr('href')!="#review"){
          $('.nav-tabs a[href="#review"]').tab('show');
        }
		$('html, body').animate({
          scrollTop: $("#tabs-information").offset().top
        }, 1000);        
        return false;
    });
  
    var youtube = document.querySelectorAll( ".youtube-video" );
    
    for (var i = 0; i < youtube.length; i++) {        
      var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/hqdefault.jpg";
        
      var image = new Image();
      image.src = source;
      image.addEventListener( "load", function() {
        youtube[ i ].appendChild( image );
      }( i ) );

      youtube[i].addEventListener( "click", function() {

        var iframe = document.createElement( "iframe" );

        iframe.setAttribute( "frameborder", "0" );
        iframe.setAttribute( "allowfullscreen", "" );
        iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );

        this.innerHTML = "";
        this.appendChild( iframe );
      } );    
    };
    
});


function onScrollInit(items, trigger) {
        items.each(function () {
            var osElement = $(this),
                osAnimationClass = osElement.attr('data-os-animation'),
                osAnimationDelay = osElement.attr('data-os-animation-delay');

            osElement.css({
                '-webkit-animation-delay': osAnimationDelay,
                '-moz-animation-delay': osAnimationDelay,
                'animation-delay': osAnimationDelay
            });

            var osTrigger = (trigger) ? trigger : osElement;

            osTrigger.waypoint(function () {
                osElement.addClass('animated').addClass(osAnimationClass);
            }, {
                triggerOnce: true,
                offset: '90%'
            });
        });
    }

    onScrollInit($('.os-animation'));
    onScrollInit($('.staggered-animation'), $('.staggered-animation-container'));